import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const RegisterTenant = createAsyncThunk("dummyData/RegisterTenant", async ({values, files}, { rejectWithValue }) => {
    try {
        const formData = new FormData();
        formData.append("values", JSON.stringify(values));

        // Append files as binary
        if (files?.profilePhoto) formData.append("profilePhoto", files.profilePhoto);
        if (files?.cnicFront) formData.append("cnicFront", files.cnicFront);
        if (files?.cnicBack) formData.append("cnicBack", files.cnicBack);
        if (files?.incomeProof) formData.append("incomeProof", files.incomeProof);

        // Don't set the Content-Type header - the browser sets it automatically with the boundary
        let response = await axios.post(`${BASE_URL}/tenant-registerForm`, formData);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || { message: "Registration failed" });
    }
});



const TenantRegestration = createSlice({
    name: "TenantRegestration",
    initialState: {
        loading: false,
        TenantRegestration: [],
        error: ""
    },
    extraReducers: {
        [RegisterTenant.fulfilled]: (state, action) => {
            state.TenantRegestration = action.payload;
            state.loading = false;
        },
        [RegisterTenant.pending]: (state) => {
            state.loading = true;
        },
        [RegisterTenant.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        },
    }
});
export default TenantRegestration.reducer;